export default {
  common: {
    error: "문제가 발생했습니다",
    reload: "다시 로드",
    errorNotification: "알림을 받았으며 가능한 한 빨리 수정하겠습니다. 문제가 지속되면",
    contactUs: "문의해 주세요.",
    language: "언어",
    loading: "로딩 중...",
    loadingText: "로딩",
    save: "저장",
    savedSuccessfully: "성공적으로 저장됨",
    saving: "저장 중...",
    cancel: "취소",
    edit: "편집",
    delete: "삭제",
    add: "추가",
    search: "검색",
    filter: "필터",
    clear: "지우기",
    preview: "미리보기",
    default: "기본값: {{value}}",
    optional: "선택사항",
    required: "필수",
    noData: "데이터 없음",
  },
  // Places navigation
  places: {
    navigation: {
      locations: "위치",
      cities: "도시", 
      regions: "지역",
      countries: "국가",
      showOnMap: "지도에 표시",
      addLocation: "위치 추가"
    },
    welcome: {
      title: "Locations So Super에 오신 것을 환영합니다.",
      subtitle: "시작하려면 네비게이션에서 섹션을 선택하세요."
    }
  },

  // Cities section
  cities: {
    title: "도시",
    resourceSingular: "도시",
    resourcePlural: "도시들",
    headings: {
      name: "이름",
      status: "상태",
      locations: "위치", 
      region: "지역",
      country: "국가"
    },
    breadcrumbs: {
      cities: "도시"
    }
  },

  // Countries section  
  countries: {
    title: "국가",
    resourceSingular: "국가", 
    resourcePlural: "국가들",
    headings: {
      name: "이름",
      status: "상태",
      locations: "위치",
      cities: "도시",
      regions: "지역"
    },
    breadcrumbs: {
      countries: "국가"
    }
  },

  // Regions section
  regions: {
    title: "지역",
    resourceSingular: "지역",
    resourcePlural: "지역들", 
    headings: {
      name: "이름",
      status: "상태",
      locations: "위치",
      cities: "도시",
      country: "국가"
    },
    breadcrumbs: {
      regions: "지역"
    }
  },

  // Map section
  map: {
    title: "지도",
    breadcrumbs: {
      locations: "위치"
    }
  },

  // Import section
  import: {
    title: "CSV 가져오기",
    breadcrumbs: {
      locations: "위치"
    },
    new: {
      title: "CSV로 위치 가져오기",
      description: "필요한 형식의 예시를 보려면 샘플 CSV 템플릿을 다운로드하세요",
      sampleTemplate: "샘플 CSV 템플릿",
      uploadAndContinue: "업로드하고 계속",
      abortOnError: "오류 시 중단",
      abortOnErrorHelp: "오류가 있으면 가져오기가 중단되고 오류가 표시되며 위치가 가져와지지 않습니다.",
      needHelp: "위치 가져오기에 도움이 필요하신가요?"
    },
    show: {
      title: "CSV 가져오기",
      youCanLeavePage: "이 페이지를 떠날 수 있습니다",
      backgroundMessage: "가져오기는 백그라운드에서 계속 실행됩니다",
      importProgress: "가져오기 진행률",
      imported: "가져옴",
      suffix: "위치",
      importLog: "가져오기 로그",
      cancelImport: "가져오기 취소",
      cancelConfirmation: {
        title: "가져오기 취소",
        message: "이 가져오기 작업을 취소하시겠습니까? 이 작업은 되돌릴 수 없습니다.",
        note: "참고: 진행 중인 작업의 경우 작업이 완료된 후 바로 삭제됩니다.",
        yesCancel: "예, 가져오기 취소",
        noContinue: "아니오, 가져오기 계속"
      },
      report: "보고서",
      failedLocations: "실패한 위치",
      uploadAnother: "다른 CSV 업로드",
      backToLocations: "위치로 돌아가기",
      importSucceeded: "가져오기 성공",
      importFailed: "가져오기 실패"
    },
    messages: {
      uploadSuccess: "CSV 업로드 성공",
      uploadError: "CSV를 업로드할 수 없습니다",
      pending: "가져오기가 아직 시작되지 않았습니다",
      inProgress: "가져오기 진행 중",
      completed: "가져오기 완료",
      invalidHeader: "다음 열이 필요합니다",
      invalidCsvFile: "잘못된 CSV 파일",
      aborted: "가져오기 중단됨",
      failed: "가져오기 실패",
      cancelled: "가져오기 취소됨"
    },
    errors: {
      csvTooLarge: "CSV가 너무 큽니다",
      languageNotEnabled: "언어 '{{language}}'가 이 상점에서 활성화되지 않았습니다. 먼저 설정 > 언어에서 활성화하세요.",
      fieldNotTranslatable: "필드 '{{field}}'는 번역할 수 없습니다. 번역 가능한 필드는 {{fields}}입니다",
      locationError: "슬러그가 있는 위치: {{slug}} - {{error}}",
      planLimit: "위치에 대한 계획 한도에 도달했습니다"
    }
  },

  // Location form
  location: {
    index: {
      title: "위치",
      addLocation: "위치 추가",
      import: "가져오기",
      noPrioritySet: "우선순위 설정 안됨",
      published: "게시됨",
      draft: "초안",
      resourceSingular: "위치",
      resourcePlural: "위치들",
      headings: {
        name: "이름",
        status: "상태", 
        city: "도시",
        region: "지역",
        country: "국가",
        priority: "우선순위"
      }
    },
    form: {
      title: "위치 추가",
      editTitle: "위치 편집",
      basicInformation: "기본 정보",
      name: "이름",
      namePlaceholder: "예: 브라이언의 벽돌",
      nameHelpDefault: "기본값: {{defaultName}}",
      details: "세부사항",
      description: "설명",
      descriptionPlaceholder: "고객에게 이 위치가 특별한 이유를 알려주세요",
      address: "주소",
      addressPlaceholder: "123 메인 스트리트, 도시, 국가",
      addressLine1: "주소 1행",
      addressLine2: "주소 2행",
      postalZipCode: "우편번호",
      city: "도시",
      stateProvinceRegion: "주/도/지역",
      country: "국가",
      phone: "전화",
      phonePlaceholder: "+1 (555) 123-4567",
      email: "이메일", 
      emailPlaceholder: "store@example.com",
      website: "웹사이트",
      websitePlaceholder: "https://www.example.com",
      image: "이미지",
      imagePlaceholder: "이미지 URL 입력",
      status: "상태",
      statusActive: "활성",
      statusInactive: "비활성",
      statusDraft: "초안",
      priority: "우선순위",
      priorityHelpText: "높은 우선순위 위치가 검색 결과에서 먼저 나타납니다",
      findOnMapButton: "지도에서 찾기"
    },
    validation: {
      addressNotFound: "주소를 찾을 수 없습니다",
      createSuccess: "위치가 성공적으로 생성되었습니다", 
      updateSuccess: "위치가 성공적으로 업데이트되었습니다",
      checkFields: "필드를 확인해 주세요",
      findOnMap: "저장하기 전에 지도에서 위치를 찾아주세요"
    },
    errors: {
      loading: "위치 로딩 오류"
    },
    actions: {
      save: "위치 저장",
      delete: "위치 삭제",
      preview: "미리보기"
    },
    customFields: {
      title: "사용자 정의 필드",
      noCustomFields: "사용자 정의 필드가 구성되지 않음",
      configureFields: "필드 구성",
      emptyState: "아직 사용자 정의 필드를 구성하지 않았습니다. 사용자 정의 필드를 사용하면 비즈니스 요구사항에 특화된 추가 정보를 추가할 수 있습니다."
    },
    openingHours: {
      title: "영업시간",
      checkboxLabel: "이 위치에는 영업 시작 및 종료 시간이 있습니다",
      statusOpen: "열림",
      statusOpen24h: "24시간 영업",
      statusClosed: "닫힘",
      openingTimeLabel: "영업 시작 시간",
      closingTimeLabel: "영업 종료 시간",
      days: {
        monday: "월요일",
        tuesday: "화요일", 
        wednesday: "수요일",
        thursday: "목요일",
        friday: "금요일",
        saturday: "토요일",
        sunday: "일요일"
      }
    },
    table: {
      sortOptions: {
        recentlyAdded: "최근 추가됨",
        recentlyModified: "최근 수정됨"
      },
      filters: {
        status: "상태",
        taggedWith: "태그됨",
        locationStatus: "위치 상태",
        noTagsToShow: "표시할 태그 없음",
        searchPlaceholder: "검색"
      },
      bulkActions: {
        setPublished: "게시됨으로 설정",
        setUnpublished: "게시되지 않음으로 설정", 
        setPriority: "우선순위 설정",
        deleteLocations: "위치 삭제",
        exportCSV: "CSV로 내보내기"
      },
      appliedFilters: {
        statusIs: "상태는 {{status}}입니다",
        taggedWith: "{{tag}}로 태그됨",
        nameIncludes: "이름에 {{search}} 포함"
      },
      modals: {
        deleteTitle: "위치 삭제",
        deleteMessage: "{{count}}을(를) 삭제하시겠습니까?",
        deleteMessageAll: "모든 위치를 삭제하시겠습니까?",
        prioritiseTitle: "{{count}}개 위치 우선순위 설정",
        prioritiseTitleAll: "모든 위치 우선순위 설정",
        delete: "삭제",
        cancel: "취소"
      },
      emptyState: {
        noResultsHeading: "{{resourcePlural}}을(를) 찾을 수 없습니다",
        noResultsText: "필터나 검색어를 변경해 보세요",
        noDataHeading: "{{resourcePlural}}을(를) 채우려면 위치를 추가하세요",
        addLocation: "위치 추가",
        importFromCSV: "CSV에서 가져오기"
      },
      pagination: {
        label: "{{pages}}페이지 중 {{page}}페이지"
      },
      messages: {
        updatedSuccessfully: "성공적으로 업데이트됨",
        deletedSuccessfully: "성공적으로 삭제됨", 
        exportedSuccessfully: "성공적으로 내보내기됨",
        error: "문제가 발생했습니다"
      }
    }
  },

  // SEO Editor
  seo: {
    title: "페이지 내용",
    editTemplate: "SEO 템플릿 편집", 
    pageTitle: "제목",
    pageDescription: "설명",
    metaTitle: "제목",
    metaDescription: "설명",
    urlHandle: "URL 핸들",
    searchEnginePreview: "검색 엔진 목록 미리보기",
    editMeta: "메타 편집",
    previewMeta: "메타 미리보기",
    loading: "로딩 중...",
    editingLocaleHelp: "{{locale}} 내용 편집 중."
  },

  // SEO Templates section
  seoTemplates: {
    title: "SEO 템플릿",
    breadcrumbs: {
      seoTemplates: "SEO 템플릿"
    },
    template: {
      title: "{{templateName}} 템플릿 - {{locale}}",
      discardChanges: "변경사항 취소"
    },
    form: {
      pageContent: "페이지 내용",
      searchEnginePreview: "검색 엔진 목록 미리보기",
      title: "제목",
      description: "설명",
      pageTitle: "페이지 제목",
      metaDescription: "메타 설명",
      editingLocaleHelp: "{{locale}} 번역 편집 중. 빈 필드는 {{defaultLocale}}의 내용을 표시합니다.",
      defaultValue: "기본값: {{value}}"
    },
    language: {
      label: "언어",
      defaultHelp: "이것은 기본 언어입니다",
      editingHelp: "{{locale}} 번역 편집 중. 빈 필드는 {{defaultLocale}} 내용을 표시합니다."
    },
    banner: {
      multipleLanguagesDisabled: "다중 언어가 활성화되지 않음",
      enableInSettings: "설정에서 활성화",
      multipleLanguagesInfo: "다중 언어에 대한 SEO 템플릿을 관리하려면 언어 설정에서 국제화를 활성화하세요. 현재 {{locale}} 템플릿만 표시됩니다."
    },
    badges: {
      errors: "오류!",
      unsaved: "저장되지 않음"
    },
    messages: {
      saveSuccess: "SEO 템플릿이 성공적으로 저장됨",
      saveError: "템플릿을 저장할 수 없습니다",
      error: "오류..."
    }
  },

  // Area form
  area: {
    form: {
      basicInformation: "기본 정보",
      name: "이름",
      save: "저장",
      saving: "저장 중...",
      cancel: "취소",
      yourLocationsIn: "{{name}}의 위치",
      tableHeadings: {
        name: "이름",
        status: "상태",
        city: "도시",
        region: "지역",
        country: "국가"
      },
      resourceName: {
        singular: "{{name}} 위치",
        plural: "{{name}}의 위치들"
      }
    }
  },

  // Settings section
  settings: {
    navigation: {
      map: "지도",
      tags: "태그",
      customFields: "사용자 정의 필드",
      languages: "언어",
      plan: "계획",
      addTag: "Add tag",
      addField: "Add field"
    },
    planBadges: {
      trial: "!",
      endsSoon: "Ends soon"
    },
    common: {
      loading: "로딩 중...",
      error: "오류...",
      breadcrumbs: {
        settings: "설정"
      },
      skeleton: {
        customFields: "사용자 정의 필드",
        addField: "필드 추가",
        name: "이름",
        contentType: "콘텐츠 유형",
        usedIn: "사용 위치",
        field: "필드",
        fields: "필드들"
      },
      messages: {
        savedSuccessfully: "{{setting}} 설정이 성공적으로 저장됨",
        couldntSave: "{{setting}} 설정을 저장할 수 없습니다"
      }
    },
    map: {
      title: "지도",
      messages: {
        savedSuccessfully: "지도 설정이 성공적으로 저장됨",
        couldntSave: "설정을 저장할 수 없습니다"
      },
      mapboxToken: {
        title: "Mapbox 토큰",
        description: "매장 찾기 기능을 위해 Mapbox 토큰을 입력하세요",
        label: "Mapbox 토큰",
        placeholder: "지도를 계속 사용하려면 여기에 토큰을 입력하세요.",
        placeholderManaged: "무료 지도 로드가 소진되면 지도를 계속 사용하려면 여기에 토큰을 입력하세요.",
        helpText: "Mapbox 키 생성 지침을 따르고 위에 키를 붙여넣으세요. 문제가 발생하면 도움을 요청하세요.",
        linkInstructions: "Mapbox 키 생성 지침",
        linkSupport: "도움 요청"
      },
      managedToken: {
        title: "지도 로드",
        description: "관리형 토큰으로 최대 {{max}}개의 무료 지도 로드가 있으며, 그 후에는 자체 토큰을 생성해야 합니다."
      },
      appearance: {
        title: "외관",
        description: "지도의 시각적 모양을 변경하세요"
      },
      mapStyle: {
        title: "지도 스타일",
        options: {
          streets: "거리",
          outdoors: "야외", 
          light: "밝음",
          dark: "어둠",
          satellite: "위성",
          satelliteStreets: "위성 거리",
          navigationDay: "주간 내비게이션",
          navigationNight: "야간 내비게이션"
        }
      },
      searchBehaviour: {
        title: "검색 동작",
        description: "방문자가 지도에서 위치를 찾는 방법을 제어합니다.",
        geolocateLabel: "방문자의 위치를 자동으로 추정하고 근처 매장을 표시",
        geolocateHelp: "지리적 위치 확인이 성공하면 지도가 방문자 근처로 이동합니다. 추정된 위치를 찾을 수 없으면 지도가 시작 위치에 유지됩니다.",
        filterBehaviour: {
          title: "필터 동작",
          all: {
            label: "모든 태그",
            help: "위치가 필터에 표시되려면 선택된 모든 태그가 있어야 합니다"
          },
          any: {
            label: "임의의 태그", 
            help: "위치가 필터에 표시되려면 선택된 태그 중 하나라도 있으면 됩니다"
          }
        },
        keepSearchInView: {
          label: "검색 마커를 화면에 유지",
          help: "검색 결과가 나타나면 지도가 축소되어 모든 일치하는 위치를 표시합니다"
        },
        distanceUnits: {
          title: "거리 단위",
          km: "킬로미터",
          miles: "마일"
        },
        maxResults: {
          label: "최대 결과 수",
          help: "검색 결과에 표시되는 위치 수를 제한합니다",
          options: {
            results30: "30개 결과"
          }
        },
        maxDistance: {
          label: "최대 거리", 
          help: "검색 지점에서 이 거리 내의 위치만 표시합니다",
          options: {
            unlimited: "무제한"
          }
        },
        showLocationNames: {
          label: "제안에 위치 이름 표시",
          help: "검색 제안에 위치 이름을 표시합니다"
        },
        sortByPriority: {
          label: "거리 대신 우선순위로 정렬",
          help: "이 상자를 선택한 경우 최대 거리(무제한이 아닌)를 설정하는 것이 매우 권장됩니다. 그렇지 않으면 고객이 합리적인 거리 내에 있는 위치보다 높은 우선순위를 가진 멀리 있는 위치가 위에 나열되는 것을 보게 됩니다(더 구체적으로는 검색 쿼리)."
        }
      },
      searchResults: {
        title: "검색 결과",
        description: "지도에서 위치가 반환되는 방법을 제어합니다.",
        locationsLabel: "검색 결과 텍스트",
        locationsHelp: "검색 결과 위에 표시되는 텍스트 (예: '5개 위치 표시')",
        prefixLabel: "검색 결과 접두사", 
        prefixHelp: "결과 수 앞에 표시되는 텍스트"
      },
      popups: {
        title: "팝업",
        showPopups: {
          label: "팝업 표시",
          help: "방문자가 지도 마커를 클릭할 때 위치 세부정보를 표시합니다"
        }
             },
       whitelabel: {
         title: "화이트라벨",
         hideLabel: "'Powered by' 텍스트 숨기기",
         hideHelp: "매장 찾기에서 브랜딩을 제거합니다"
       }
    },
    languages: {
      title: "언어",
      error: "오류...",
      messages: {
        savedSuccessfully: "언어 설정이 성공적으로 저장됨",
        couldntSave: "언어 설정을 저장할 수 없습니다"
      },
      banner: {
        upgradeTitle: "다중 언어 지원에는 플랜 업그레이드가 필요합니다",
        upgradeAction: "Superest로 업그레이드",
        upgradeMessage: "기본 언어는 여전히 변경할 수 있지만, 다중 언어를 활성화하려면 업그레이드가 필요합니다.",
        disabledMessage: "현재 플랜에서 다중 언어 설정이 비활성화되어 있습니다"
      },
      defaultLanguage: {
        title: "기본 언어", 
        description: "콘텐츠가 표시될 기본 언어를 선택하세요.",
        label: "기본 언어",
        help: "특정 언어가 요청되지 않을 때 이 언어가 사용됩니다"
      },
      internationalization: {
        title: "국제화",
        description: "다중 언어를 활성화하세요. 더 많은 고객에게 도달하고 SEO를 향상시키세요.",
        enableLabel: "다중 언어 활성화",
        enableHelp: "고객이 다양한 언어로 매장 찾기를 볼 수 있도록 허용합니다"
      },
      supportedLanguages: {
        title: "추가 지원 언어",
        description: "지원하려는 추가 언어를 선택하세요. 언어를 활성화하면 앱 전체에서 번역을 제공할 수 있는 옵션이 표시됩니다. 지원되는 언어의 경우 기본 SEO 템플릿과 일반 변수 테마가 자동으로 생성됩니다.",
        defaultLocaleNote: "이것은 기본 언어이며 비활성화할 수 없습니다",
        shopifyEnabled: {
          label: "이 언어는 내 Shopify 스토어에서 활성화되어 있습니다",
          importantNote: "중요:",
          description: "이 언어가 Shopify 스토어에서 활성화되지 않았거나 게시되지 않은 경우 위의 상자를 선택 해제하세요. 더 나은 고객 경험을 위해 아직 하지 않았다면 Shopify 관리자의 설정 > 언어로 이동하여 먼저 Shopify 스토어에서 언어를 활성화하는 것이 권장됩니다."
        },
        urlFormats: {
          cleanUrls: "깔끔한 URL:",
          betterSeo: "더 나은 SEO 및 사용자 경험",
          queryUrls: "쿼리 매개변수 URL:",
          considerEnabling: "더 나은 URL을 위해 Shopify에서 활성화를 고려하세요"
        },
        preview: {
          button: "미리보기",
          tooltip: "{{language}} 매장 찾기 미리보기"
        },
        tooltips: {
          noTemplates: "이 언어에 사용할 수 있는 기본 SEO 템플릿이 없습니다. 사용자 정의 번역을 쉽게 만들 수 있습니다."
        }
      }
    },
    tags: {
      title: "태그",
      addTag: "태그 추가",
      error: "오류",
      messages: {
        deletedSuccessfully: "태그가 성공적으로 삭제됨",
        couldntDelete: "태그를 삭제할 수 없습니다",
        savedSuccessfully: "태그가 성공적으로 저장됨",
        couldntSave: "필드를 확인해 주세요",
        tagDeleted: "태그가 성공적으로 삭제됨"
      },
      resourceName: {
        singular: "태그",
        plural: "태그들"
      },
      filters: {
        anyGroup: "임의의 그룹",
        inGroup: "그룹 내",
        tagGroup: "태그 그룹"
      },
      appliedFilters: {
        inGroup: "{{group}} 그룹 내",
        nameContains: "태그 이름에 {{query}} 포함"
      },
      bulkActions: {
        deleteTag: "태그 삭제",
        deleteTags: "태그들 삭제"
      },
      form: {
        language: "언어",
        title: "제목",
        description: "설명",
        group: "그룹",
        groupPlaceholder: "그룹 선택",
        addGroup: "추가",
        editingTranslations: "{{language}} 번역 편집 중. 빈 필드는 {{defaultLanguage}}의 내용을 표시합니다.",
        defaultValue: "기본값: {{value}}",
        image: "이미지",
        imageUrl: "이미지 URL"
      },
      actions: {
        save: "저장",
        deleteTag: "태그 삭제"
      },
      new: {
        title: "태그 추가",
        messages: {
          createSuccess: "태그가 성공적으로 생성됨",
          checkFields: "필드를 확인해 주세요"
        },
        actions: {
          createTag: "태그 생성"
        }
      }
    },
    customFields: {
      title: "사용자 정의 필드",
      addField: "필드 추가",
      error: "오류",
      resourceName: {
        singular: "필드",
        plural: "필드들"
      },
      headings: {
        name: "이름",
        contentType: "콘텐츠 유형",
        usedIn: "사용 위치"
      },
      emptyState: {
        heading: "사용자 정의 필드를 생성하고 관리하세요",
        createAction: "필드 생성",
        description: "위치에 대한 고유한 속성을 위해 사용자 정의 필드를 사용하세요. 이러한 필드는 소셜 프로필부터 매장 관리자의 이름과 이메일까지 무엇이든 될 수 있습니다"
      },
      pluralization: {
        location: "위치",
        locations: "위치들"
      },
      form: {
        name: "이름",
        contentType: "콘텐츠 유형",
        key: "키",
        keyPrefix: "location.fields.",
        keyHelp: "이 키를 사용하여 liquid 템플릿에서 위치의 {{name}} 콘텐츠에 액세스하세요.",
        translations: {
          title: "번역",
          showTranslations: "번역 표시",
          hideTranslations: "번역 숨기기",
          description: "번역은 선택사항입니다. 빈 필드는 {{language}} 필드 이름을 표시합니다.",
          nameTranslation: "이름 ({{language}})",
          defaultValue: "기본값: {{value}}"
        }
      },
      messages: {
        savedSuccessfully: "필드가 성공적으로 저장됨",
        couldntSave: "필드를 저장할 수 없습니다",
        deletedSuccessfully: "필드가 성공적으로 삭제됨",
        couldntDelete: "필드를 삭제할 수 없습니다"
      },
      actions: {
        delete: "삭제"
      },
      new: {
        title: "필드 추가",
        messages: {
          savedSuccessfully: "필드가 성공적으로 저장됨",
          couldntSave: "필드를 저장할 수 없습니다"
        }
      },
      contentTypes: {
        text: "텍스트",
        textArea: "텍스트 영역", 
        email: "이메일",
        number: "숫자",
        phoneNumber: "전화번호",
        time: "시간",
        url: "URL"
      }
    },
    plan: {
      title: "플랜",
      error: "오류",
      changePlan: "플랜 변경",
      usdPerMonth: "USD / 월",
      sections: {
        yourPlanIncludes: "플랜에 포함된 항목",
        nextBillingDate: "다음 결제일",
        trial: "체험판"
      },
      banners: {
        planUpdated: "플랜이 업데이트되었습니다",
        thankYouUpgrading: "업그레이드해 주셔서 감사합니다!",
        letUsKnow: "알려주세요",
        improvementText: "더 잘할 수 있는 것이 있다면.",
        trialCancellation: {
          title: "평가판 취소 안내",
          message: "유료 플랜으로 업그레이드하면 14일 무료 평가판이 취소됩니다."
        }
      },
      locations: {
        upTo: "최대",
        locations: "위치",
        unlimited: "무제한 위치",
        used: "사용됨",
        ofUsed: "{{max}}개 중 {{used}}개 사용됨"
      },
      trial: {
        daysLeft: "{{days}}일 남음",
        daysUsed: "{{total}}일 중 {{used}}일 사용됨",
        selectPlan: "플랜 선택",
        currentPlan: "현재 플랜",
        trialBadge: "체험판",
        currentBadge: "현재",
        yourTrialJustStarted: "체험판이 방금 시작되었습니다",
        trialEndsAfterToday: "체험판이 오늘 이후에 종료됩니다",
        trialEndsTomorrow: "체험판이 내일 종료됩니다",
        daysLeftInTrial: "체험판 {{days}}일 남음",
        continueAddingLocations: "플랜을 선택하여 {{date}} 이후에 위치 추가를 계속하세요",
        selectPlanToday: "위치 추가를 계속하려면 오늘 플랜을 선택해 주세요"
      },
      footer: {
        description: "Locations So Super 플랜을 관리하거나 변경하세요. 다음을 확인하세요",
        termsOfService: "서비스 약관",
        and: "및",
        privacyPolicy: "개인정보 처리방침"
      },
      features: {
        analytics: {
          title: "분석",
          description: "사람들이 위치를 어떻게 사용하고 어디서 검색하는지 알아보세요"
        },
        internationalization: {
          title: "다중 언어 지원",
          description: "다중 언어를 활성화하여 SEO를 향상시키고 대상 시장에서 더 많은 고객에게 도달하세요"
        },
        customThemes: {
          editLiquid: {
            title: "테마 liquid 템플릿 편집",
            description: "테마 liquid에 액세스하여 원하는 방식으로 위치 데이터를 표시하세요"
          },
          editStructuredData: {
            title: "비즈니스 구조화 데이터 편집",
            description: "구조화 데이터를 편집하여 Google이 페이지를 이해하는 방식을 편집하세요"
          }
        }
      },
      edit: {
        title: "플랜 변경",
        allPlansInclude: "위의 모든 플랜에는 다음이 포함됩니다",
        needingMoreLocations: "더 많은 위치가 필요하신가요?",
        footerQuestion: "시작하기 전에 질문이 있으신가요?",
        sendMessage: "메시지를 보내주세요",
        allFeatures: {
          seoDirectory: {
            title: "SEO 디렉토리 및 랜딩 페이지",
            description: "모든 위치, 도시 및 지역의 SEO 디렉토리를 자동으로 생성합니다"
          },
          mapPage: {
            title: "검색 및 필터가 있는 지도 페이지",
            description: "Mapbox로 구동되는 지도에서 모든 위치를 검색하고 필터링합니다"
          },
          tags: {
            title: "태그",
            description: "이미지와 설명이 있는 태그를 생성하고 그룹화합니다"
          },
          openingHours: {
            title: "영업시간",
            description: "위치의 영업시간을 설정하고 표시합니다"
          },
          mapStyles: {
            title: "지도 스타일",
            description: "여러 사전 설정 스타일로 지도의 모양을 변경합니다"
          },
          customFields: {
            title: "사용자 정의 필드",
            description: "소셜 링크부터 매장 관리자까지 원하는 모든 새 필드를 추가하세요"
          },
          csvUpload: {
            title: "CSV로 업로드 및 내보내기",
            description: "위치를 업로드하고 일괄 편집합니다."
          },
          richSnippets: {
            title: "리치 스니펫",
            description: "로컬 비즈니스 구조화 데이터로 Google이 페이지를 더 잘 이해하도록 도와줍니다"
          },
          directionsAndCalls: {
            title: "길찾기 및 통화",
            description: "방문자가 쉽게 길찾기를 받고 위치에 전화할 수 있습니다"
          },
          languageSupport: {
            title: "언어 지원",
            description: "기본 언어를 영어가 아닌 다른 언어로 변경하세요. 32개 주요 언어에 대한 번역 템플릿이 쉬운 설정을 위해 제공됩니다."
          }
        }
      },
      planCard: {
        bestToCustomize: "맞춤 설정에 최적",
        currentPlan: "현재 플랜",
        chooseThisPlan: "이 플랜 선택",
        locationsSection: "위치",
        featuresSection: "기능",
        upTo: "최대",
        locations: "위치",
        tooltipTooManyLocations: "이 플랜에 비해 너무 많은 위치 및/또는 활성화된 언어가 있습니다."
      },
      confirmation: {
        error: "플랜 확인 오류"
      }
    }
  },

  // Themes section
  themes: {
    title: "테마",
    currentTheme: {
      title: "현재 테마",
      description: "고객이 위치 앱을 방문할 때 보는 테마입니다."
    },
    themeLibrary: {
      title: "테마 라이브러리", 
      description: "위치 테마를 관리하세요. 테마를 추가하고 게시하여 온라인 위치의 외관을 변경하세요."
    },
    skeleton: {
      currentThemeDescription: "고객이 위치 앱을 사용할 때 보는 테마입니다."
    },
    modal: {
      overrideTitle: "현재 테마를 덮어쓰시겠습니까?",
      override: "덮어쓰기",
      cancel: "취소",
      undoWarning: "이 작업은 되돌릴 수 없습니다."
    },
    messages: {
      publishSuccess: "테마가 성공적으로 게시됨",
      publishError: "테마를 게시할 수 없습니다",
      error: "문제가 발생했습니다"
    },
    emptyStates: {
      settings: {
        heading: "이 테마에는 설정이 없습니다",
        description: "템플릿 편집기에서 설정을 생성하세요.",
        createSettings: "설정 생성",
        upgradePlan: "플랜 업그레이드",
        upgradeRequired: "설정을 생성하려면 플랜을 업그레이드하세요"
      },
      language: {
        heading: "이 테마에는 언어 용어가 없습니다",
        description: "템플릿 편집기에서 언어 용어를 생성하세요.",
        createLanguageTerms: "언어 용어 생성",
        upgradePlan: "플랜 업그레이드",
        upgradeRequired: "언어 용어를 생성하려면 플랜을 업그레이드하세요"
      }
    },
    templates: {
      categories: {
        templates: "템플릿",
        schemas: "스키마",
        styles: "스타일",
        liquidReference: "Liquid 참조"
      },
      items: {
        landing: "랜딩",
        directory: "디렉토리",
        country: "국가",
        region: "지역",
        city: "도시",
        location: "위치",
        language: "언어",
        settings: "설정",
        stylesheet: "스타일시트"
      },
      errors: {
        errorsInTemplate: "템플릿의 오류",
        error: "오류"
      },
      badges: {
        errors: "오류!",
        unsaved: "저장되지 않음"
      },
      actions: {
        viewTheme: "테마 보기",
        discard: "취소",
        save: "저장"
      }
    },
    language: {
      messages: {
        saveSuccess: "테마 언어 번역이 성공적으로 저장됨",
        saveError: "테마를 저장할 수 없습니다"
      },
      form: {
        language: "언어",
        defaultLanguageHelp: "이것은 기본 언어입니다",
        translationHelp: "{{selectedLocale}} 번역 편집 중. 빈 필드는 {{defaultLocale}}(기본 언어)의 내용을 표시합니다."
      },
      banner: {
        multipleLanguagesNotEnabled: {
          title: "다중 언어가 활성화되지 않음",
          action: "설정에서 활성화",
          description: "다중 언어 번역을 관리하려면 언어 설정에서 국제화를 활성화하세요. 현재 {{locale}} 번역만 표시됩니다."
        },
        translating: {
          title: "{{from}}에서 {{to}}로 번역 중",
          description: "비워두는 모든 필드는 고객에게 자동으로 {{defaultLocale}} 내용을 표시합니다. {{selectedLocale}}에서 다른 내용을 원하는 필드만 번역하세요."
        }
      },
      accessLanguageTerms: "liquid에서 {{code}}로 {{category}} 언어 용어에 액세스하세요",
      fields: {
        // Common language fields - add specific ones as needed
        title: "제목",
        description: "설명",
        heading: "제목",
        subheading: "부제목",
        button_text: "버튼 텍스트",
        link_text: "링크 텍스트",
        placeholder: "플레이스홀더",
        label: "라벨",
        help_text: "도움말 텍스트",
        error_message: "오류 메시지",
        success_message: "성공 메시지",
        
        // Opening hours
        Monday: "월요일",
        Tuesday: "화요일",
        Wednesday: "수요일",
        Thursday: "목요일",
        Friday: "금요일",
        Saturday: "토요일",
        Sunday: "일요일",
        opening_hours_format: "영업시간 형식",
        closes_at_format: "마감 시간 형식",
        opens_at_format: "개점 시간 형식",
        opens_on: "개점일",
        open_24h: "24시간 영업",
        open: "열림",
        closed: "닫힘",
        closes_at: "마감 시간",
        opens_at: "개점 시간",
        
        // Map
        search_map: "지도 검색",
        search_area: "이 지역 검색",
        view_map: "지도",
        view_list: "목록",
        open_filters: "필터",
        stores_near_you: "근처 매장",
        header: "매장 찾기!",
        search_placeholder: "우편번호나 주소를 입력하세요...",
        no_listings: "죄송합니다. 검색 결과에 해당하는 위치를 찾을 수 없습니다. 필터나 검색 위치를 변경해 보세요",
        
        // Directory
        view_directory: "매장 디렉토리",
        
        // Location
        get_directions: "길찾기",
        call: "전화",
        view_website: "웹사이트",
        email: "이메일",
        opening_hours_header: "영업시간",
        description_header: "정보",
        phone_number_header: "전화",
        address_header: "주소",
        tag_groups_to_display: "표시할 태그 그룹"
      },
      categories: {
        // Common language categories - add specific ones as needed
        general: "일반",
        navigation: "네비게이션",
        forms: "양식",
        buttons: "버튼",
        messages: "메시지",
        errors: "오류",
        opening_hours: "영업시간",
        map: "지도",
        directory: "디렉토리",
        location: "위치"
      }
    },
    settings: {
      messages: {
        saveSuccess: "Theme saved successfully",
        saveError: "Theme couldn't save"
      },
      accessSettings: "Access the {{category}} settings in liquid with {{code}}",
      fields: {
        // Colors
        color_text: "Color text",
        color_text_heading: "Color text heading", 
        color_background: "Color background",
        color_accent: "Color accent",
        color_text_positive: "Color text positive",
        color_text_negative: "Color text negative",
        dark_theme: "Dark theme",
        color_marker: "Color marker",
        color_search_marker: "Color search marker",
        
        // Typography
        base_font_size: "Base font size",
        
        // Buttons
        border_radius: "Border radius",
        
        // Images
        aspect_ratio: "Aspect ratio",
        fit: "Fit",
        
        // Spacing
        page_width: "Page width",
        page_width_small: "Page width small",
        gutter_desktop: "Gutter desktop",
        gutter_mobile: "Gutter mobile",
        desktop_vertical_spacing: "Desktop vertical spacing",
        mobile_vertical_spacing: "Mobile vertical spacing",
        
        // Breakpoints
        breakpoint_xs: "Breakpoint XS",
        breakpoint_sm: "Breakpoint SM",
        breakpoint_md: "Breakpoint MD",
        
        // Map
        search_on_move: "Search on move",
        scroll_to_zoom: "Scroll to zoom",
        
        // Landing page
        sidebar_width: "Sidebar width",
        sidebar_min_height: "Sidebar min height",
        marker_image_src: "Marker image source",
        show_filter_descriptions: "Show filter descriptions",
        
        // Location page
        tag_groups_to_display: "Tag groups to display",
        tag_groups_to_display_as_icons: "Tag groups to display as icons",
        show_related_locations: "Show related locations",
        
        // Locations
        hide_regions: "Hide regions"
      },
      categories: {
        colors: "Colors",
        typography: "Typography",
        buttons: "Buttons",
        images: "Images",
        spacing: "Spacing",
        breakpoints: "Breakpoints",
        map: "Map",
        landing_page: "Landing page",
        location_page: "Location page",
        locations: "Locations"
      }
    },
    navigation: {
      sublimeTheme: "Sublime Theme",
      settings: "Settings",
      language: "Language",
      templates: "Templates",
      changeTheme: "Change theme",
      viewDirectory: "View directory",
      viewLandingPage: "View landing page"
    },
    card: {
      lastUpdated: "Last updated",
      view: "View",
      customize: "Customize",
      publish: "Publish",
      actions: "Actions"
    }
  },

  // Analytics section
  analytics: {
    title: "분석",
    timePeriods: {
      last7days: "최근 7일",
      last30days: "최근 30일"
    },
    comparison: {
      compareToPrevious: "이전 기간과 비교",
      stopComparing: "이전 기간과의 비교 중지"
    },
    sections: {
      searchLocations: "위치 검색"
    },
    cards: {
      sessions: "세션",
      topSearches: "인기 검색",
      topLandingPageType: "인기 랜딩 페이지 유형",
      topPageViewsBySession: "세션별 인기 페이지 뷰",
      topLocations: "인기 위치",
      topReferrers: "인기 참조 사이트",
      searches: "검색",
      topLandingPagesBySession: "세션별 인기 랜딩 페이지"
    },
    chartLabels: {
      desktop: "데스크톱"
    }
  },

}; 